import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarketSeoComponent } from './market-seo.component';
import { RouterModule, Routes } from '@angular/router';
import { ProductsSectionComponent } from './products-section/products-section.component';
import { ShippingSectionComponent } from './shipping-section/shipping-section.component';
import { MostPopularSectionComponent } from './most-popular-section/most-popular-section.component';
import { CategoriesSectionComponent } from './categories-section/categories-section.component';
import {LoadXemartScriptResolver} from '@app/resolvers/load-xemart-script.resolver';
import {SharedModule} from '@app/marketplace/shared/shared.module';
import {NgxSkeletonLoaderModule} from 'ngx-skeleton-loader';
import { PaymentConfirmationComponent } from './payment-confirmation/payment-confirmation.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { AmmazonBannerComponent } from './ammazon-banner/ammazon-banner.component';
import {LayoutModule} from '@app/marketplace/layout/layout.module';
import { SheinBannerComponent } from './shein-banner/shein-banner.component';
import { WalmartBannerComponent } from './walmart-banner/walmart-banner.component';
import { HomeDepotBannerComponent } from './home-depot-banner/home-depot-banner.component';
import { BestBuyBannerComponent } from './best-buy-banner/best-buy-banner.component';

/*const routes: Routes = [
  { path: '', component: MarketSeoComponent, resolve: {cres: LoadXemartScriptResolver} },
  { path: 'vende-tus-productos', loadChildren: () => import('../market-supplier/market-supplier.module').then(m => m.MarketSupplierModule) },
];*/

@NgModule({
    declarations: [MarketSeoComponent, ProductsSectionComponent, ShippingSectionComponent, MostPopularSectionComponent, CategoriesSectionComponent, PaymentConfirmationComponent, AmmazonBannerComponent, SheinBannerComponent, WalmartBannerComponent, HomeDepotBannerComponent, BestBuyBannerComponent],
    exports: [
        MostPopularSectionComponent,
        HomeDepotBannerComponent
    ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    NgxSkeletonLoaderModule,
    FormsModule,
    ReactiveFormsModule,
  ]
})
export class MarketSeoModule { }
